module.exports = __webpack_public_path__ + "static/media/5.e826cb21.png";